import styled from 'styled-components';

export const Container = styled.div`
  width: 700px;
  margin: 0 auto;
  ul {
    padding: 0;
    li {
      list-style-type: none;
    }
  }
  img {
    max-width: 100%;
  }
`;
